import { StoreModel } from 'src/graphql/generated/graphql';

export const getAddress = (
  restaurant: Pick<StoreModel, 'postalCode' | 'city' | 'address1'>,
) => {
  if (!restaurant) {
    return '';
  }

  const address = [
    restaurant?.postalCode,
    restaurant?.city,
    restaurant?.address1,
  ]
    .filter((item) => !!item)
    .join(' ');

  return address;
};
